import React, { useEffect, useState } from "react";
import { Table, DatePicker, Typography, Space, Spin, message } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { getTenantReports } from "../../services/reports";

const { Title } = Typography;
const { RangePicker } = DatePicker;

const TenantRevenueReport = () => {
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(1, "month"),
    dayjs(),
  ]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchReport = async (start, end) => {
    try {
      setLoading(true);
      const res = await getTenantReports({startDate:start,endDate:end})

      if (res?.success) {
        setData(res.data);
      } else {
        message.error("Failed to fetch tenant revenue.");
      }
    } catch (err) {
      console.error(err);
      message.error("Error while fetching data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport(dateRange[0], dateRange[1]);
  }, []);

  const columns = [
    {
      title: "Tenant Name",
      dataIndex: "tenantName",
      key: "tenantName",
    },
    {
      title: "Tenant ID",
      dataIndex: "_id",
      key: "_id",
    },
    {
      title: "Total Revenue (₹)",
      dataIndex: "totalRevenue",
      key: "totalRevenue",
      render: (amount) => <strong>₹{amount || 0}</strong>,
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={4}>Tenant Revenue Report</Title>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <RangePicker
          style={{ width: "100%", maxWidth: 400 }}
          value={dateRange}
          onChange={(dates) => {
            if (dates) {
              setDateRange(dates);
              fetchReport(dates[0], dates[1]);
            }
          }}
          allowClear={false}
        />

        <Spin spinning={loading}>
          <Table
            dataSource={data}
            columns={columns}
            rowKey="_id"
            bordered
            pagination={{ pageSize: 10 }}
          />
        </Spin>
      </Space>
    </div>
  );
};

export default TenantRevenueReport;
